export default __webpack_public_path__ + "static/media/second.21c7ea12.svg";